/**
 * JQUERY: Generic get error message from Response class error.
 * @param {Object|String} jqXhr JQuery xhr object or an Error object
 * @returns {String}
 */
const jqGetAjaxError = function ({
    message = '',
    responseText = '',
}) {
    if (message) {
        return message;
    }
    if (!responseText) {
        return 'Error';
    }
    try {
        const response = JSON.parse(responseText);
        if (response.error) {
            return response.error;
        }
    } catch {
        // just avoiding json parse issues
    }
    return 'Error';
};

export {
    jqGetAjaxError,
};
